import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { AssetPipe } from 'src/app/pipes/asset.pipe';
import { TranslationService } from 'src/app/services/translation.service';
@Component({
  selector: 'contact-us',
  standalone: true,
  imports: [AssetPipe],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContactUsComponent implements OnInit {
  translationLabels: any;
  constructor(private translationService: TranslationService) { }

  ngOnInit() {
    this.translationLabels = this.translationService.getTranslationForPage('contact-us');
  }
}
